var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPessangers({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 94,
    height: 91,
    viewBox: "0 0 94 91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10268",
    "data-name": "Group 10268",
    transform: "translate(0.345)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_47",
    "data-name": "Path 47",
    transform: "translate(-0.345)",
    fill: "#ffd200"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 81 90.25 L 13 90.25 C 9.727912902832031 90.25 6.651662349700928 88.97577667236328 4.337937355041504 86.66206359863281 C 2.024224996566772 84.34833526611328 0.75 81.27208709716797 0.75 78 L 0.75 13 C 0.75 9.727912902832031 2.024224996566772 6.651662349700928 4.337937355041504 4.337937355041504 C 6.651662349700928 2.024224996566772 9.727912902832031 0.75 13 0.75 L 81 0.75 C 84.27208709716797 0.75 87.34833526611328 2.024224996566772 89.66206359863281 4.337937355041504 C 91.97577667236328 6.651662349700928 93.25 9.727912902832031 93.25 13 L 93.25 78 C 93.25 81.27208709716797 91.97577667236328 84.34833526611328 89.66206359863281 86.66206359863281 C 87.34833526611328 88.97577667236328 84.27208709716797 90.25 81 90.25 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 13 1.5 C 9.928237915039062 1.5 7.040336608886719 2.696212768554688 4.868263244628906 4.868263244628906 C 2.696212768554688 7.040336608886719 1.5 9.928237915039062 1.5 13 L 1.5 78 C 1.5 81.07176208496094 2.696212768554688 83.95966339111328 4.868263244628906 86.13173675537109 C 7.040336608886719 88.30378723144531 9.928237915039062 89.5 13 89.5 L 81 89.5 C 84.07176208496094 89.5 86.95966339111328 88.30378723144531 89.13173675537109 86.13173675537109 C 91.30378723144531 83.95966339111328 92.5 81.07176208496094 92.5 78 L 92.5 13 C 92.5 9.928237915039062 91.30378723144531 7.040336608886719 89.13173675537109 4.868263244628906 C 86.95966339111328 2.696212768554688 84.07176208496094 1.5 81 1.5 L 13 1.5 M 13 0 L 81 0 C 88.17970275878906 0 94 5.820289611816406 94 13 L 94 78 C 94 85.17970275878906 88.17970275878906 91 81 91 L 13 91 C 5.820289611816406 91 0 85.17970275878906 0 78 L 0 13 C 0 5.820289611816406 5.820289611816406 0 13 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user-alt",
    "data-name": "Icon awesome-user-alt",
    d: "M21.686,24.4a12.2,12.2,0,1,0-12.2-12.2A12.2,12.2,0,0,0,21.686,24.4Zm10.843,2.711H27.861a14.746,14.746,0,0,1-12.351,0H10.843A10.842,10.842,0,0,0,0,37.95v1.355a4.067,4.067,0,0,0,4.066,4.066H39.305a4.067,4.067,0,0,0,4.066-4.066V37.95A10.842,10.842,0,0,0,32.528,27.107Z",
    transform: "translate(25.655 24)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPessangers);
export default __webpack_public_path__ + "static/media/pessangers.b19723e113199775bed95bfee6a33ecd.svg";
export { ForwardRef as ReactComponent };